"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingWrapper = void 0;
const React = __importStar(require("react"));
/** A wrapper component that displays a non-interactive loading overlay and progress bar when isLoading is true. */
exports.LoadingWrapper = ({ isLoading, children, style = {}, className = "" }) => {
    const containerStyles = Object.assign(Object.assign({}, style), { position: "relative" });
    if (isLoading) {
        containerStyles.pointerEvents = "none";
        containerStyles.opacity = 0.5;
    }
    return (React.createElement("div", { className: className, style: containerStyles },
        children,
        isLoading && (React.createElement(React.Fragment, null,
            React.createElement(CursorOverlay, { cursorType: "wait" }),
            React.createElement(UnobstrusiveLoadingBar, null)))));
};
function CursorOverlay({ cursorType }) {
    return React.createElement("div", { style: {
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            cursor: cursorType,
            zIndex: 9998,
            pointerEvents: "all"
        } });
}
function UnobstrusiveLoadingBar() {
    return React.createElement("div", { style: {
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "3px",
            background: "#e0e0e0",
            zIndex: 9999,
            overflow: "hidden"
        } },
        React.createElement("div", { style: {
                height: "100%",
                width: "30%",
                background: "linear-gradient(90deg, #007acc, #4fc3f7)",
                animation: "loading-progress 2s ease-in-out infinite",
                borderRadius: "0 2px 2px 0"
            } }));
}
//# sourceMappingURL=loading-wrapper.js.map